import { CustomModalConfig } from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.component';
import { IPolicies } from 'services/policy-permission/policy-permissions.service';

export enum NOTIFICATION_TEMPLATES {
  RED_ALERT = 1,
  YELLOW_ALERT,
  LICENSE_EXPIRING,
  LICENSE_EXPIRED,
  LICENSE_SPECIALTY_EXPIRING,
  LICENSE_SPECIALTY_EXPIRED,
  VERIFICATION_DUE,
  VERIFICATION_PAST_DUE,
  LICENSE_RENEWAL_DUE,
  LICENSE_RENEWAL_PAST_DUE,
  MISC_WORKFLOW_DUE,
  MISC_WORKFLOW_PAST_DUE,
  LICENSE_STATUS_CHANGE,
  REMINDER,
  DOCUMENT_UPLOADED,
  ONBOARDING_WORKFLOW_DUE = 16,
  ONBOARDING_WORKFLOW_PAST_DUE = 17,
  ONBOARDING_PSV_SUCCESS = 18,
  ONBOARDING_PSV_FAILURE = 19,
}

export const NOTIFICATION_TEMPLATE_IDS_WITH_NA_TRIGGER: number[] = [
  NOTIFICATION_TEMPLATES.RED_ALERT,
  NOTIFICATION_TEMPLATES.YELLOW_ALERT,
  NOTIFICATION_TEMPLATES.LICENSE_STATUS_CHANGE,
  NOTIFICATION_TEMPLATES.REMINDER,
  NOTIFICATION_TEMPLATES.DOCUMENT_UPLOADED,
  NOTIFICATION_TEMPLATES.ONBOARDING_PSV_SUCCESS,
  NOTIFICATION_TEMPLATES.ONBOARDING_PSV_FAILURE,
];

export enum TRIGGER_TYPES {
  days = 1,
  weeks = 2,
  months = 3,
}

export const TRIGGER_TYPE_OPRIONS: { name: string; id: number }[] = [
  {
    id: 1,
    name: TRIGGER_TYPES[1],
  },
  {
    id: 2,
    name: TRIGGER_TYPES[2],
  },
  {
    id: 3,
    name: TRIGGER_TYPES[3],
  },
];

export const UNSAVED_MODAL_CONFIG: CustomModalConfig = {
  title: 'Unsaved changes',
  body: 'Do you really want to proceed without saving?',
  defaultButtonText: 'Cancel',
  primaryButtonText: 'Proceed',
  isPrimaryButtonVisible: true,
};

export const PREVIEW_MODAL_CONFIG: CustomModalConfig = {
  title: '',
  isCloseCrossVisible: false,
  hasCustomFooter: true,
  type: 'organization',
  hideHeader: true,
};

export const SETTINGS_MODAL_CONFIG: CustomModalConfig = {
  title: '',
  isCloseCrossVisible: false,
  hasCustomFooter: true,
  type: 'organization',
  hideHeader: true,
};

export enum NotificationPath {
  generalSettings = 'general-settings',
  adminSettings = 'admin-settings',
}

export const NotificationTabs = [
  {
    display: 'General Notification Settings',
    link: NotificationPath.generalSettings,
  },
  {
    display: 'Admin Notification Settings',
    link: NotificationPath.adminSettings,
  },
];
